<lib-panel-layout>
  <div class="flex flex-col items-stretch w-full min-w-0 gap-3 xl:items-center">
    <lib-text-input
      class="w-full"
      [label]="'EDITOR.WATERMARK.TEXT' | translate"
      [value]="text"
      placeholder="Watermark Text"
      (changed)="onTextChanged($event)">
    </lib-text-input>

    <!--
      Temporarily hidden: font selection will be restored after backend exposes
      available fonts list for frontend.
    <div class="edit-wrapper">
      <span class="edit-label">{{ 'EDITOR.WATERMARK.FONT_NAME' | translate }}</span>
      <select class="font-select" [value]="fontName" (change)="onFontNameChanged($event)">
        @for (fontName of availableFontNames; track fontName) {
        <option [value]="fontName" [style.font-family]="fontName">{{ fontName }}</option>
        }
      </select>
    </div>
    -->

    <div class="flex flex-wrap md:grid md:grid-cols-3 lg:flex lg:flex-col gap-2 w-full items-center">
      <lib-color-picker
        class="w-40 md:w-full"
        [label]="'EDITOR.WATERMARK.TEXT_COLOR' | translate"
        [value]="textColor"
        (changed)="onTextColorChanged($event)">
      </lib-color-picker>

      <lib-number-input
        class="w-40 md:w-full"
        [label]="'EDITOR.WATERMARK.FONT_SIZE' | translate"
        [value]="fontSize"
        [min]="8"
        [max]="256"
        (changed)="onFontSizeChanged($event)"
        unit="px">
      </lib-number-input>

      <lib-number-input
        class="w-40 md:w-full"
        [label]="'EDITOR.WATERMARK.ROTATION' | translate"
        [value]="rotationAngleDegrees"
        [min]="-180"
        [max]="180"
        (changed)="onRotationChanged($event)"
        unit="deg">
      </lib-number-input>
    </div>
  </div>

  <lib-apply-panel panelActions class="w-full" (apply)="onApply()" (cancelRequested)="onCancel()"></lib-apply-panel>
</lib-panel-layout>
